import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class FileHttpService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/file`;

  uploadFile(file: File): Observable<string> {
    const data = new FormData();
    data.append('File', file);
    return this.http.post<{fileId: string}>(`${this.url}/me`, data).pipe(map(x => x.fileId));
  }
}
